import { getFragmentData } from '@/__generated__';
import { GATE_MOVEMENT_FRAGMENT } from '../graphql/fragments/gateMovementFragment';
import { GateMovementFragmentFragment } from '@/__generated__/graphql';

export const getMovementFragmentData = (movementFragment: {
  ' $fragmentRefs'?: {
    GateMovementFragmentFragment: GateMovementFragmentFragment;
  };
}) => {
  const movement = getFragmentData(GATE_MOVEMENT_FRAGMENT, movementFragment);
  return movement;
};
